import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TablesService {

  /* Behavior Subjects */
  // Studies
  private userSelectedIDSource = new BehaviorSubject<number>(null);
  private userSelectedObjectIDSource = new BehaviorSubject<number>(null);
  private selectedStudyNameSource = new BehaviorSubject<string>(null);
  private userSelectedRecordsSource = new BehaviorSubject<[]>(null);
  // Elevations
  private elevationsSelectedSource = new BehaviorSubject<[]>(null);

  /* Observables */
  // Studies
  userSelectedID = this.userSelectedIDSource.asObservable();
  userSelectedObjectID = this.userSelectedObjectIDSource.asObservable();
  selectedStudyName = this.selectedStudyNameSource.asObservable();
  userSelectedRecords = this.userSelectedRecordsSource.asObservable();
  // Elevations
  elevationsSelected = this.elevationsSelectedSource.asObservable();

  constructor(private http: HttpClient) { }

  // Update user selected ID number (fs_id) AND selected object ID
  changeUserSelectedID(id: number, objectid: number, studyName: string) {
    this.userSelectedIDSource.next(id);
    this.userSelectedObjectIDSource.next(objectid);
    this.selectedStudyNameSource.next(studyName);
  }

  // Update user selection study record
  updateUserSelectedRecord(userSelection: any) {
    this.userSelectedRecordsSource.next(userSelection);
  }

  // Update elevation user selection record
  updateElevationsSelected(elevationSelection: any) {
    this.elevationsSelectedSource.next(elevationSelection);
  }

}
